import axios from 'axios';

const { vin65 } = window;

export const init = () => { // eslint-disable-line import/prefer-default-export
  const modalCart = document.getElementById('v65-modalCartDropdown');
  if (!modalCart) {
    return false;
  }

  prepareDefaultModalCart();
  addToCartSubmit();
  v65CustomCartResponse();
  v65CustomCartToggle();
  customizeModalCart();
  return modalCart;
};

const prepareDefaultModalCart = () => document.body.classList.add('vt__modal-cart-enabled');

const addToCartSubmit = () => {
  const addToCartForms = [...document.querySelectorAll('[v65js=addToCart]')];
  if (!addToCartForms.length) {
    return false;
  }

  // Can't override Vin65 event without wrapping in DOMContentLoaded event
  return document.addEventListener('DOMContentLoaded', () => {
    addToCartForms.forEach(form => form.addEventListener('submit', handleAddToCartSubmit, false));
  });
};

const customizeModalCart = () => {
  const vtModalCart = document.getElementsByClassName('vt__modal-cart');
  if (!vtModalCart.length) {
    const modalCart = document.createElement('div');
    modalCart.className = 'vt__modal-cart';
    modalCart.innerHTML = `
      <div class="vt__modal-cart__header">
        <h4>Cart</h4>
        <a href="#" class="vt__modal-cart__close"></a>
      </div>
      <div class="vt__modal-cart__carrot"></div>
      <div class="vt__modal-cart__items"></div>
      <div class="vt__modal-cart__checkout"></div>
    `;
    document.body.appendChild(modalCart);
  }

  return getCartResponseJSON()
    .then((cart) => {
      formatModalCart(cart);
    })
    .catch((err) => {
      console.error('err', err);
    });
};

const v65CustomCartResponse = () => {
  const v65CartResponse = vin65.cart.cartResponse;
  vin65.cart.cartResponse = (response) => {
    v65CartResponse(response);
    $('#v65-modalCartDropdown')
      .stop(true, true).removeAttr('style'); // Stop jQuery animation from Vin65

    customizeModalCart()
      .then(() => {
        showCart();
      });
  };
};

const v65CustomCartToggle = () => {
  vin65.cart.toggleCart = () => {
    document.getElementsByClassName('vt__modal-cart')[0].classList.toggle('vt__modal-cart--visible');
  };
};

const handleAddToCartSubmit = (event) => {
  $('html, body').stop(); // Stop jQuery animation from Vin65
  const productSKU = event.target.children.productSKU.value;
  const cartProduct = document.querySelector(`.vt__modal-cart__item[data-sku="${productSKU}"]`);
  if (cartProduct) {
    cartProduct.classList.add('vt__modal-cart__item--updating');
  }
};

const getCartResponseJSON = () => {
  const cartObject = {};
  let cartVersion = '';
  const v2Cart = window.hasCheckoutV2 === 1;
  if (v2Cart) {
    cartVersion = 'V2';
  }
  return axios.get(`/index.cfm?method=cart${cartVersion}.showCart&overrideLayout=1&timestamp=${new Date().getTime()}`, {
    responseType: 'text',
  })
    .then((res) => {
      const html = new DOMParser().parseFromString(res.data, 'text/html');

      if (v2Cart) {
        return html.getElementsByClassName('v65-checkoutCart')[0];
      }

      return html.getElementById('v65-cartTable');
    })
    .then((cart) => {
      let cartItems = [];
      let subtotal = 0;
      if (cart) {
        cartItems = [...cart.getElementsByClassName('v65-cartItem')];
        if (v2Cart) {
          subtotal = cart.getElementsByClassName('v65-subtotal')[0].getElementsByClassName('v65-value');
        } else {
          subtotal = cart.getElementsByClassName('v65-cartSubtotal-6');
        }
      }

      cartObject.items = cartItems.map((cartItem) => {
        if (v2Cart) {
          return jsonCartItemV2(cartItem);
        }

        return jsonCartItem(cartItem);
      });

      cartObject.subtotal = subtotal.length && subtotal[0].innerText;
      return cartObject;
    })
    .catch((err) => {
      console.error('err', err);
    });
};

const jsonCartItem = (cartItem) => {
  const cartImage = cartItem.getElementsByClassName('v65-cartItemImage')[0];
  const cartDescription = cartItem.getElementsByClassName('v65-cartItemDescription')[0];
  const updateAmount = cartItem.getElementsByClassName('v65-cartItemAmount')[0];
  return {
    drilldownLink: cartImage.firstElementChild.getAttribute('href'),
    image: cartImage.getElementsByTagName('img')[0].getAttribute('src'),
    title: cartDescription.getElementsByTagName('strong')[0].innerText.trim(),
    price: cartItem.getElementsByClassName('v65-cartItemPrice')[0].innerText.trim(),
    total: cartItem.getElementsByClassName('v65-cartItemTotal')[0].innerText.trim(),
    quantity: parseInt(cartItem.getElementsByClassName('v65-qtyField')[0].value, 10),
    removeItem: cartItem.getElementsByClassName('v65-cartRemoveButton')[0].getAttribute('href'),
    updateQuantityAction: updateAmount.getElementsByTagName('form')[0].getAttribute('action'),
    sku: updateAmount.querySelector('input[name=productSKU]').value,
  };
};

const jsonCartItemV2 = (cartItem) => {
  const cartImage = cartItem.getElementsByClassName('v65-image')[0];
  return {
    drilldownLink: cartImage.getAttribute('href'),
    image: cartImage.getElementsByTagName('img')[0].getAttribute('src'),
    title: cartItem.getElementsByClassName('v65-itemTitle')[0].innerText.trim(),
    price: cartItem.getElementsByClassName('v65-price')[0].innerText.trim(),
    total: cartItem.getElementsByClassName('v65-totalPrice')[0].innerText.trim(),
    quantity: parseInt(cartItem.getElementsByClassName('v65-qtyField')[0].value, 10),
    removeItem: cartItem.getElementsByClassName('v65-removeItem')[0].getAttribute('href'),
    updateQuantityAction: cartItem.getElementsByTagName('form')[0].getAttribute('action'),
    sku: cartItem.getElementsByClassName('v65-itemTitle')[0].firstElementChild.dataset.sku,
  };
};

const formatModalCart = (cart) => {
  axios.get('/index.cfm?method=cart.showModalCart')
    .then((res) => {
      const html = new DOMParser().parseFromString(res.data, 'text/html');
      const modalCartToggle = document.getElementById('v65-toggleModalCart');
      const newCartToggle = html.getElementById('v65-toggleModalCart');
      document.getElementById('v65-modalCart').replaceChild(newCartToggle, modalCartToggle);
      return html.getElementById('v65-modalCartDropdown');
    })
    .then((v65ModalCart) => {
      const carrots = v65ModalCart.getElementsByClassName('v65-carrot');
      const vtCarrot = document.getElementsByClassName('vt__modal-cart__carrot')[0];
      if (carrots.length) {
        vtCarrot.innerHTML = carrots[0].outerHTML;
      } else {
        vtCarrot.innerHTML = '';
      }

      const vtCheckoutButton = document.getElementsByClassName('vt__modal-cart__checkout')[0];
      if (cart.items.length) {
        let checkoutLink = '/index.cfm?method=checkout.billing';
        if (window.hasCheckoutV2) {
          checkoutLink = '/index.cfm?method=checkoutV2.login';
        }

        vtCheckoutButton.innerHTML = `
          <a href="${checkoutLink}" class="largeLinkBtn">
            Checkout - ${cart.subtotal}
          </a>
        `;
      } else {
        vtCheckoutButton.innerHTML = '';
      }

      const modalCartItems = document.getElementsByClassName('vt__modal-cart__items')[0];
      modalCartItems.innerHTML = renderCartItems(cart.items).join('');

      updateItemQuantity();
      removeItemFromCart();
      closeModalCartEvent();
    })
    .catch((err) => {
      console.error('err', err);
    });
};

const renderCartItems = items => items.map(item => `
  <div class="vt__modal-cart__item" data-sku="${item.sku}">
    <div class="vt__modal-cart__item__image">
      <a href="${item.drilldownLink}">
        <img src="${item.image}" alt="${item.title}" />
      </a>
    </div>

    <div class="vt__modal-cart__item__details">
      <a href="${item.drilldownLink}" class="vt__modal-cart__item__title">${item.title}</a>
      <input
        type="tel"
        class="vt__modal-cart__item__quantity"
        value="${item.quantity}"
        data-sku="${item.sku}"
        data-action="${item.updateQuantityAction}"
      />
      <span class="vt__modal-cart__item__price">x ${item.price}</span>
      <a href="${item.removeItem}" class="vt__modal-cart__item__remove">Remove</a>
    </div>

    <div class="vt__modal-cart__item__total">${item.total}</div>
  </div>
`);

const updateItemQuantity = () => {
  const quantityInputs = [...document.getElementsByClassName('vt__modal-cart__item__quantity')];
  quantityInputs.forEach((quantityInput) => {
    quantityInput.addEventListener('change', handleItemQuantityUpdate, false);
  });
};

const handleItemQuantityUpdate = (event) => {
  event.target.parentElement.parentElement.classList.add('vt__modal-cart__item--updating');
  const quantity = event.target.value;
  const productSKU = event.target.getAttribute('data-sku');
  const action = event.target.getAttribute('data-action');
  const formData = new FormData();
  formData.append('productSKU', productSKU);
  formData.append('quantity', quantity);
  axios.post(action, formData)
    .then(() => {
      customizeModalCart();
    })
    .catch((err) => {
      console.error('err', err);
    });
};

const removeItemFromCart = () => {
  const removeLinks = [...document.getElementsByClassName('vt__modal-cart__item__remove')];
  removeLinks.forEach((link) => {
    ['touchstart', 'click'].forEach(event => link.addEventListener(event, handleRemoveItem, false));
  });
};

const handleRemoveItem = (event) => {
  event.preventDefault();
  event.target.parentElement.parentElement.classList.add('vt__modal-cart__item--updating');
  axios.get(event.target.href)
    .then(() => {
      customizeModalCart();
    });
};

const closeModalCartEvent = () => {
  const closeModalCartButtons = [...document.getElementsByClassName('vt__modal-cart__close')];
  closeModalCartButtons.forEach((link) => {
    ['touchstart', 'click'].forEach(event => link.addEventListener(event, handleHideCart, false));
  });
};

const showCart = () => {
  document.getElementsByClassName('vt__modal-cart')[0].classList.add('vt__modal-cart--visible');
};

const hideCart = () => {
  document.getElementsByClassName('vt__modal-cart')[0].classList.remove('vt__modal-cart--visible');
};

const handleHideCart = (event) => {
  event.preventDefault();
  hideCart();
};



// WEBPACK FOOTER //
// ./src/assets/js/modalCart.js